import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Chaos from './Chaos';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Chaos />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js